/*
 * File: index.tsx
 * Desc: 表格编辑复选框组件
 * File Created: 2019-12-05 17:23:15
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React, { useState } from 'react';
import { Checkbox } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';

interface IOption {
    key: CheckboxValueType;
    value: CheckboxValueType;
}

interface TdCheckboxRenderProps {
    options?: IOption[];
    onChange?: (checkedValue: CheckboxValueType[]) => void;
    value?: CheckboxValueType[];
    disabled?: boolean;
}
/** 表格编辑复选框组件 */
const TdCheckboxRender = (props: TdCheckboxRenderProps) => {
    const [value, setValue] = useState(props.value);
    function onChange(value: CheckboxValueType[]) {
        setValue(value);
        props.onChange && props.onChange(value);
    }
    return (
        <Checkbox.Group onChange={onChange} value={value} disabled={props.disabled}>
            {props.options &&
                props.options.map(option => (
                    <Checkbox value={option.key}>{option.value || option.key}</Checkbox>
                ))}
        </Checkbox.Group>
    );
};

export default TdCheckboxRender;
